import React from 'react';
import get from 'lodash/get';
import Ad from '../../ad/ad';

export default function PhotoEssaySection(props) {
  // const index = get(props, 'index', '');
  const lastSection = get(props, 'lastSection', false);
  const combinedAdModel = get(props, 'combinedAdModel', '');
  const header = get(props, 'section.section_header', '');
  const description = get(props, 'section.section_description', '');
  const photos = get(props, 'section.photos', []);

  return (
    <div className="photo-essay-section">
      <div className="border" />
      <p className="header">{header}</p>
      <p className="description">{description}</p>
      {photos.map(photo => {
        const format = get(photo, 'format', '');
        if (format === '1 Column') {
          let title;
          let image = get(photo, 'image_1_upload.url', '');
          if (image) {
            title = get(photo, 'image_1_upload.title', '');
          } else {
            image = get(photo, 'image_1_url', '');
            title = null;
          }
          const caption = get(photo, 'image_1_caption', '');

          return (
            <div className="image-row">
              <img src={image} alt={title} />
              <div className="caption"> {caption} </div>
            </div>
          );
        }
        if (format === '2 Column') {
          let title;
          let image = get(photo, 'image_1_upload.url', '');
          if (image) {
            title = get(photo, 'image_1_upload.title', '');
          } else {
            image = get(photo, 'image_1_url', '');
            title = null;
          }
          const caption = get(photo, 'image_1_caption', '');

          let title2;
          let image2 = get(photo, 'image_2_upload.url', '');
          if (image2) {
            title2 = get(photo, 'image_2_upload.title', '');
          } else {
            image2 = get(photo, 'image_2_url', '');
            title2 = null;
          }
          const caption2 = get(photo, 'image_2_caption', '');

          return (
            <div className="image-row two-column">
              <div className="two-column-container">
                <img src={image} alt={title} />
                <div className="caption"> {caption} </div>
              </div>
              <div className="two-column-container">
                <div>
                  <img src={image2} alt={title2} />
                  <div className="caption"> {caption2} </div>
                </div>
              </div>
            </div>
          );
        }
        return null;
      })}
      {!lastSection && (
        <div>
          <Ad {...combinedAdModel} name="flexibleleaderboard" pos="atf" />
          <Ad {...combinedAdModel} name="mobileleaderboard" pos="atf" />
        </div>
      )}
    </div>
  );
}
